<div
    *ngIf="myForm && formControlChildName"
    [formGroup]="myForm"
    [ngStyle]="{ height: height, width: width }"
    class="image-uploader form-group"
    [ngClass]="{ 'has-file': (imageUrl || pdfUrl) && formControlChildName != 'attachments' }"
    id="testUplaod"
>
    <ng-container *ngIf="myFormGroupName" [formGroupName]="myFormGroupName">
        <img loading="lazy" 
            *ngIf="loading"
            class="uploading-spinner"
            src="assets/images/Spinner-loading.svg"
            alt="loading image"
        />
        <embed
            *ngIf="isPdf"
            [src]="pdfUrl"
            scrolling="no"
            type="application/pdf"
            frameBorder="0"
            scrolling="0"
        />
        <img loading="lazy" 
            *ngIf="!isPdf && imageUrl"
            [src]="imageUrl"
            alt="Image"
            class="bordered-img"
        />
        <img loading="lazy" 
            *ngIf="!isPdf && !imageUrl"
            [src]="fallbackImage"
            alt="fallback Image"
            class="bordered-img-placeholder"
        />
        <input
            (input)="onImageSelected($event)"
            #mainUploader
            accept="{{
                fileType && fileType.length > 0 ? 'image/*' : 'image/*,.pdf,.doc,.docx'
            }}"
            name="uploader"
            type="file"
        />
        <div class="realative-actions" [ngClass]="{ 'd-none': noPreview }">
            <div class="action-btns d-flex justify-content-center">
                <button
                    (click)="mainUploader.click()"
                    type="button"
                    class="btn action-btn"
                >
                    <mat-icon class="text-muted">edit</mat-icon>
                </button>
                <a [href]="imageUrl" target="_blank" class="btn action-btn">
                    <mat-icon>remove_red_eye</mat-icon>
                </a>
                <button
                    (click)="removeFile(formControlChildName)"
                    type="button"
                    class="btn action-btn"
                    id="closeImg"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <input
            [formControlName]="formControlChildName"
            class="input-wrapper"
            name="uploaderwraper"
            type="text"
        />
    </ng-container>

    <ng-container *ngIf="!myFormGroupName">
        <img loading="lazy" 
            *ngIf="loading"
            class="uploading-spinner"
            src="assets/images/Spinner-loading.svg"
            alt="loading image"
        />
        <embed
            *ngIf="isPdf"
            [src]="pdfUrl"
            scrolling="no"
            type="application/pdf"
            frameBorder="0"
            scrolling="0"
        />
        <img loading="lazy" 
            *ngIf="!isPdf && imageUrl"
            [src]="imageUrl"
            alt="Image"
            class="bordered-img"
        />
        <img loading="lazy" 
            *ngIf="!isPdf && !imageUrl"
            [src]="fallbackImage"
            alt="fallback Image"
            class="bordered-img-placeholder"
        />
        <input
            (input)="onImageSelected($event)"
            #mainUploader
            accept="{{
                fileType && fileType.length > 0 ? 'image/*' : 'image/*,.pdf,.doc,.docx'
            }}"
            name="uploader"
            type="file"
        />
        <div class="realative-actions" [ngClass]="{ 'd-none': noPreview }">
            <div class="action-btns d-flex justify-content-center">
                <button
                    (click)="mainUploader.click()"
                    type="button"
                    class="btn action-btn"
                >
                    <mat-icon class="text-muted">edit</mat-icon>
                </button>
                <a [href]="imageUrl" target="_blank" class="btn action-btn">
                    <mat-icon>remove_red_eye</mat-icon>
                </a>
                <button
                    (click)="removeFile(formControlChildName)"
                    type="button"
                    class="btn action-btn"
                    id="closeImg"
                >
                    <mat-icon>close</mat-icon>
                </button>
            </div>
        </div>

        <input
            [formControlName]="formControlChildName"
            class="input-wrapper"
            name="uploaderwraper"
            type="text"
        />
    </ng-container>
</div>

<div
    *ngIf="!(myForm && formControlChildName)"
    [ngStyle]="{ height: height, width: width }"
    class="image-uploader form-group"
    [ngClass]="{ 'has-file': imageUrl || pdfUrl }"
>
    <img  loading="lazy" 
        *ngIf="loading"
        class="uploading-spinner"
        src="assets/images/Spinner-loading.svg"
           alt="loading image"
    />
    <embed *ngIf="isPdf" [src]="pdfUrl" type="application/pdf" />
    <img  loading="lazy" 
        *ngIf="!isPdf && imageUrl"
        [src]="imageUrl"
           alt="image"
        class="bordered-img"
    />
    <img  loading="lazy" 
        *ngIf="!isPdf && !imageUrl"
        [src]="fallbackImage"
           alt="fallback Image"
        class="bordered-img-placeholder"
    />
    <input
        (input)="onImageSelected($event)"
        #mobileUploader
        accept="{{
            fileType && fileType.length > 0 ? 'image/*' : 'image/*,.pdf,.doc,.docx'
        }}"
        name="uploader"
        type="file"
    />
    <div class="realative-actions" [ngClass]="{ 'd-none': noPreview }">
        <div class="action-btns d-flex justify-content-center">
            <button
                (click)="mobileUploader.click()"
                type="button"
                class="btn action-btn"
            >
                <mat-icon class="text-muted">edit</mat-icon>
            </button>
            <a [href]="imageUrl" target="_blank" class="btn action-btn">
                <mat-icon>remove_red_eye</mat-icon>
            </a>
            <button
                (click)="removeFile(formControlChildName)"
                type="button"
                class="btn action-btn"
            >
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <input class="input-wrapper" name="uploaderwraper" type="text" />
</div>
